<script setup>
import TableCell from "@/components/global-themed/table/TableCell.vue";
import TableRow from "@/components/global-themed/table/TableRow.vue";
import DomainAuthorityTag from "@/components/competition/partials/backlinks/AuthorityTag.vue";
import useDates from "@/composables/useDates";
import {computed} from "vue";
import {useStore} from "vuex";

defineProps({
  backlink: {
    type: Object,
    required: true,
  }
});

const store = useStore();

const dates = useDates();

const view = computed(() => store.getters['competitionV2/backlinksView']);

</script>

<template>
  <TableRow class="tw-grid-cols-16">
    <TableCell
      v-if="view === 'simple'"
      col-span="4"
    >
      <span class="tw-truncate tw-w-auto tw-block">{{ backlink.domain }}</span>
    </TableCell>
    <TableCell
      :col-span="view === 'simple' ? 5 : 4"
    >
      <div
        v-if="view === 'advanced'"
      >
        {{ backlink.domain }}
      </div>
      <a
        :href="backlink.url"
        :title="backlink.url"
        target="_blank"
        class="tw-text-blue tw-underline tw-truncate tw-w-auto tw-block"
      >
        {{ backlink.relativeUrl }}
      </a>
    </TableCell>
    <TableCell
      class="tw-flex tw-justify-center"
      col-span="2"
    >
      <DomainAuthorityTag :value="backlink.domainAuthority" />
    </TableCell>
    <TableCell
      class="tw-flex tw-justify-center"
      col-span="2"
    >
      <DomainAuthorityTag :value="backlink.pageAuthority" />
    </TableCell>
    <TableCell col-span="2">
      {{ dates.formattedDate(backlink.found) }}
    </TableCell>
    <TableCell
      v-if="view === 'advanced'"
      col-span="2"
    >
      {{ backlink.noFollow ? 'Nofollow' : 'Follow' }}
    </TableCell>
    <TableCell
      v-if="view === 'advanced'"
      col-span="2"
    >
      <div
        class="tw-max-w-full tw-truncate"
        :title="backlink.anchorText"
      >
        {{ backlink.anchorText }}
      </div>
    </TableCell>
    <TableCell
      v-if="view === 'advanced'"
      col-span="2"
    >
      {{ backlink.linkType }}
    </TableCell>
  </TableRow>
</template>
